// Local translations
export const T = {
  en_GB: {
    searchInstrumentDatabase: "Search Instrument Database",
    searchDescription: "Search for instruments to automatically fill in product details.",
    patchInstrumentTitle: "Patch Instrument",
    patchInstrumentDescription: "Search for an instrument to update the data source connection.",
    dataSource: "Data Source",
    searchByName: "Search by name",
    searchPlaceholder: "e.g., Storebrand, DNB, etc.",
    pleaseEnterAtLeast: "Please enter at least 2 characters",
    failedToSearch: "Failed to search",
    searching: "Searching...",
    search: "Search",
    showingResults: (p: { from: string; to: string; total: string }) =>
      `Showing ${p.from}-${p.to} of ${p.total} results`,
    showingAllResults: (total: string) => `Showing all ${total} results`,
    name: "Name",
    isin: "ISIN",
    currency: "Currency",
    exchange: "Exchange",
    action: "Action",
    select: "Select",
    noInstrumentsFound: "No instruments found matching",
    tryDifferentSearch: "Try a different search term",
    enterNameToSearch: "Enter a name to search",
    cancel: "Cancel",
    previous: "Previous",
    next: "Next",
    pageOf: (page: string, totalPages: string) => `Page ${page} of ${totalPages}`,
    maxResultsWarning: (limit: string) =>
      `Showing maximum ${limit} results. Try a more specific search to find all matches.`,
    fetchingMetadata: "Fetching instrument details...",
    failedToFetchMetadata: "Failed to fetch instrument details",
    notLinkedWarning:
      "Product will NOT be linked to the database. You can still save it with the search data (name and ISIN).",
    insufficientHistoricalDataTitle: "Insufficient Historical Data",
    insufficientHistoricalDataDescription:
      "Instrument does not have historical data for the last 10 years",
  },
  nb_NO: {
    searchInstrumentDatabase: "Søk i instrumentdatabase",
    searchDescription: "Søk etter instrumenter for å automatisk fylle inn produktdetaljer.",
    patchInstrumentTitle: "Oppdater instrument",
    patchInstrumentDescription: "Søk etter et instrument for å oppdatere datakildetilkoblingen.",
    dataSource: "Datakilde",
    searchByName: "Søk etter navn",
    searchPlaceholder: "f.eks. Storebrand, DNB, osv.",
    pleaseEnterAtLeast: "Vennligst skriv inn minst 2 tegn",
    failedToSearch: "Søk mislyktes",
    searching: "Søker...",
    search: "Søk",
    showingResults: (p: { from: string; to: string; total: string }) =>
      `Viser ${p.from}-${p.to} av ${p.total} resultater`,
    showingAllResults: (total: string) => `Viser alle ${total} resultater`,
    name: "Navn",
    isin: "ISIN",
    currency: "Valuta",
    exchange: "Børs",
    action: "Handling",
    select: "Velg",
    noInstrumentsFound: "Ingen instrumenter funnet som matcher",
    tryDifferentSearch: "Prøv et annet søkeord",
    enterNameToSearch: "Skriv inn et navn for å søke",
    cancel: "Avbryt",
    previous: "Forrige",
    next: "Neste",
    pageOf: (page: string, totalPages: string) => `Side ${page} av ${totalPages}`,
    maxResultsWarning: (limit: string) =>
      `Viser maksimalt ${limit} resultater. Prøv et mer spesifikt søk for å finne alle treff.`,
    fetchingMetadata: "Henter instrumentdetaljer...",
    failedToFetchMetadata: "Kunne ikke hente instrumentdetaljer",
    notLinkedWarning:
      "Produktet vil IKKE bli koblet til databasen. Du kan fortsatt lagre det med søkedataene (navn og ISIN).",
    insufficientHistoricalDataTitle: "Utilstrekkelig historiske data",
    insufficientHistoricalDataDescription:
      "Instrumentet har ikke historiske data for de siste 10 årene",
  },
} as const;
